import AuthenticationLayout from 'components/AuthLayout';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import MentorFormEdit from 'components/UserForms/MentorForm/MentorFormEdit';
import {
  Errors,
  initialErrors,
  State,
} from 'components/UserForms/MentorForm/types';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR, { mutate } from 'swr';
import MentorFormType from 'types/MentorForm';
import privateAPI from 'utils/privateAxiosInstance';

const initialState: State = {
  jobSearch: null,
  careerPlan: null,
  studies: null,
  entrepreneurship: null,
  expertises: [],
  formations: [],
  diploma: [],
  consideration: null,
  hobby: null,
  wantedMentorships: 0,
  heardAboutMentorship: null,
  heardAboutMentorshipText: null,
  expectations: null,
  sharingPhone: null,
  sharingEmail: null,
};
const FillFormMentor: FC = () => {
  const [state, setState] = useState<State>(initialState);
  const [errors, setErrors] = useState<Errors>(initialErrors);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const { data: mentorForm, error } = useSWR<MentorFormType>('/mentor-form/');
  useEffect(() => {
    if (mentorForm) {
      setState({
        jobSearch: mentorForm.jobSearch!,
        careerPlan: mentorForm.careerPlan!,
        studies: mentorForm.studies!,
        entrepreneurship: mentorForm.entrepreneurship!,
        expertises: mentorForm.expertiseFields!.map(
          (expertiseField) => expertiseField.expertise,
        ),
        formations: mentorForm.formations!.map(
          (mentorFormation) => mentorFormation.formation,
        ),
        diploma: mentorForm.diploma!.map(
          (mentorDiploma) => mentorDiploma.diploma,
        ),
        consideration: mentorForm.consideration!,
        hobby: mentorForm.hobby!,
        wantedMentorships: mentorForm.wantedMentorships!,
        heardAboutMentorship: mentorForm.heardAboutMentorship || null,
        heardAboutMentorshipText: mentorForm.heardAboutMentorshipText || null,
        expectations: mentorForm.expectations || null,
        sharingPhone: mentorForm.sharingPhone!,
        sharingEmail: mentorForm.sharingEmail!,
      });
    }
  }, [mentorForm]);

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors(initialErrors);

    if (!state.expectations || state.expectations.split(',').filter(Boolean).length === 0) {
      setLoading(false);
      window.scrollTo({ top: 0 });
      return setErrors({
        ...initialErrors,
        expectations: true,
      });
    }

    if (!(state.sharingEmail || state.sharingPhone)) {
      setLoading(false);
      return setErrors({
        ...initialErrors,
        permissions: true,
      });
    }

    privateAPI
      .post('/mentor-form/', {
        ...state,
        diploma: state.diploma,
      })
      .then((res) => {
        mutate('/mentor-form/');
        setLoading(false);
        window.scrollTo({ top: 0 });
        !res?.data?.invalid && navigate('/mentor/fill-profile');
      })
      .catch((err) => {
        window.scrollTo({ top: 0 });
        setLoading(false);
        if (err?.response?.status === 400) {
          return setErrors({
            ...initialErrors,
            badRequest: true,
          });
        }
        setErrors({
          ...initialErrors,
          general: true,
        });
      });
  };

  return mentorForm || error ? (
    <AuthenticationLayout
      title="Mentorer un jeune avec l'Institut de l'Engagement (1/3)"
      backTo="/mentor/welcome"
      src_image="/logo_institut_mentorat.png"
    >
      <MentorFormEdit
        title="Questionnaire de mentorat"
        subtitle={[
          'Grâce à vos réponses, nous identifierons le jeune avec lequel vous serez mis en relation.',
          'Ce jeune aura répondu à un questionnaire similaire, ce qui nous permettra de plus facilement identifier les binômes à constituer.',
          'IMPORTANT : les binômes seront formés selon la complémentarité de vos profils plutôt que sur la proximité géographique.',
        ]}
        marginTop="4.5rem"
        {...{ state, setState, handleSubmit, errors, setErrors, loading }}
        invalid={mentorForm?.invalid}
      />
    </AuthenticationLayout>
  ) : (
    <LoaderContainer height="calc(100vh - 3rem)">
      <DefaultLoader size={2} />
    </LoaderContainer>
  );
};

export default FillFormMentor;
